import React, { useEffect, useState } from "react";
import { Button } from "@vds/buttons";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/system";
import "../../styles/deviceStyle.css";
import OrganizationTable from "../../global/components/Tables/OrganizationTable";
import { fetchRequest,updatePaginationRequest } from "../../store/actions/organization";
import { searchPopUpUpdate } from "../../store/actions/globalSearch";
import { useSelector, useDispatch } from "react-redux";
import CreateOrganization from "./CreateOrganization";
const Organization = () => {
  const dispatch = useDispatch();
  const stateObj = useLocation();

  const { search } = stateObj.state || { search: "" };
  const resultState = stateObj.state && stateObj.state.id ? stateObj.state : null;

  const searchPopUpData = useSelector((state) => state.globalSearch.navigateSearchPopUp);
 

  const user = useSelector((state) => state.auth.user);
  const organizationList = useSelector((state) => state.organization.data?.organizations);
  const alarmCounts = useSelector((state) => state.organization.alarmCounts);
  const currentModal = useSelector((state) => state.organization.currentModal);

  //const filters = useSelector((state) => state?.organization?.filters);
  const isLoadingAlarmCount = useSelector(
    (state) => state.organization.isLoadingAlarmCount
  );
  const [tableLoading, setTableLoading] = useState(false);
  const [selectedOrganization, setSelectedOrganization] = useState();
  const [pageLoading, setPageLoading] = useState(true);
  const [orgPopupVisible, setOrgPopupVisible] = useState(searchPopUpData);
  useEffect(() => {
 // dispatch(fetchRequest());
    setOrgPopupVisible(searchPopUpData);
    setSelectedOrganization(resultState);
     dispatch(
                  updatePaginationRequest({
                    name: { value: "", sort: "" },
                    lastUpdatedto: "", 
                    lastUpdatedfrom: "",
                    sort: "desc",
                    field: "createdon",
                  })
                );
  }, [dispatch, searchPopUpData, resultState, user?.accountId]);

 useEffect(() => {
     dispatch(updatePaginationRequest({
        name: { value: "", sort: "" },
        lastUpdatedto: "", 
        lastUpdatedfrom: "",
        sort: "desc",
        field: "createdon",
      })
    );
  }, []);
  const createOrganization = () => {
    setOrgPopupVisible(true);
  };
  const closeorgPopup = () => {
    setOrgPopupVisible(false);
    dispatch(searchPopUpUpdate(false))
  };
  const handleOrgCreatedAdd = () => {
    setOrgPopupVisible(false);
    dispatch(searchPopUpUpdate(false))
    dispatch(fetchRequest());
    setSelectedOrganization(null);
  };
  return (
    <div style={{ minHeight: "65vh", margin: "0 auto" }}>
      <Box sx={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
           <h2
            className="page-common-heading_tittle"
          >
            Organizations
          </h2>
          <div>
            {user?.role?.permissions?.organizations?.create ? (
              <Button
                style={{
                  backgroundColor: "black",
                  color: "white",
                  fontSize: "16px",
                  lineHeight: '20px',
                  letterSpacing: '0.5px',
                  fontWeight: 700,
                }}
                size="large"
                shape="round"
                use="primary"
                onClick={createOrganization}
              >
                Add organization
              </Button>
            ) : (
              <></>
            )}
          </div>
        </div>
      </Box>
      <OrganizationTable
        key={search}
        organizationList={organizationList}
        alarmCounts={alarmCounts}
        isLoadingAlarmCount={isLoadingAlarmCount}
        permissions={user?.role?.permissions}
        searchOrg={search || ""}
        selectedOrganization={selectedOrganization}
        setSelectedOrganization={setSelectedOrganization}
        tableLoading={tableLoading}
        tableTitle="Active rules"
        currentModal={currentModal}
      />
      {orgPopupVisible && (
        <CreateOrganization
          visible={orgPopupVisible}
          state={selectedOrganization}
          closePopup={closeorgPopup}
          onOrgCreated={handleOrgCreatedAdd}
        />
      )}
    </div>
  );
};
export default Organization;
